export default __webpack_public_path__ + "static/media/A.7adfd49d.png";